import { render, staticRenderFns } from "./ordTask.vue?vue&type=template&id=05c72f83&scoped=true&"
import script from "./ordTask.vue?vue&type=script&lang=js&"
export * from "./ordTask.vue?vue&type=script&lang=js&"
import style0 from "./ordTask.vue?vue&type=style&index=0&id=05c72f83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c72f83",
  null
  
)

export default component.exports